"use client";

import React from "react";
import { SizingOptions } from "modules/common/components/CardPreviewLoading";
import { TradeItem } from "modules/tradeLists/model/tradeList";
import { CardPreviewSizing } from "utils/styles";
import { TradeItemGridCell } from "modules/common/components/TradeItemGridCell";

interface Props {
  item: TradeItem;
  sizing?: SizingOptions;
  showRelationship?: boolean;
  /** Opt out of the trader avatar + name (owner-on-own-list, picker). */
  hideUser?: boolean;
  /** Enable multi-select checkboxes (crossfades with message button) */
  enableMultiSelect?: boolean;
  priority?: boolean;
  /** Owner-only: absolutely-positioned overlay (e.g. "more actions" menu). */
  actionsOverlay?: React.ReactNode;
  /** Owner-only: override the card image click (defaults to card details modal). */
  onImageClick?: () => void;
  /** Suppress the bottom action button (owner-on-own-list — link is redundant). */
  hideAction?: boolean;
  /** Hide the relative timestamp ("3h ago") — owner-on-own-list doesn't need it. */
  hideTime?: boolean;
  /** Mute the card and block selection (every copy is already in an active proposal). */
  selectionDisabled?: boolean;
}

export const TradePreviewCard = ({
  item,
  sizing = CardPreviewSizing,
  showRelationship = false,
  hideUser = false,
  enableMultiSelect = false,
  priority,
  actionsOverlay,
  onImageClick,
  hideAction,
  hideTime,
  selectionDisabled,
}: Props) => {
  return (
    <TradeItemGridCell
      item={item}
      sizing={sizing}
      priority={priority}
      fromMatch={showRelationship}
      hideUser={hideUser}
      enableMultiSelect={enableMultiSelect}
      actionsOverlay={actionsOverlay}
      onImageClick={onImageClick}
      hideAction={hideAction}
      hideTime={hideTime}
      selectionDisabled={selectionDisabled}
    />
  );
};

export default TradePreviewCard;
